<template>
    <!-- 五险统计表 -->
    <div>
        <!-- <div style="font-size:20px;float:left;margin:40px;font-weight:600">五险统计表</div> -->
        <div style="height:auto;background-color:white;margin:5px 5px 20px 5px;padding-bottom: 20px;">
            <!-- 查询框 -->
            <div style="margin-left:3%">
                <el-row style=" padding: 20px 0;">
                    <el-col :span="6">
                        <div style="display:inline-block">
                            <span>组织架构</span>
                            <el-cascader v-model="condition.organize_ids" clearable style="margin-left:10px;width:300px"
                                collapse-tags :props="props"></el-cascader>
                        </div>
                    </el-col>
                    <!-- <el-col :span="4">
                        <span>时间</span>
                        <el-date-picker v-model="condition.years_date" type="month" placeholder="请选择" :clearable="false"
                            value-format="yyyy-MM" style="margin-left: 10px;width: 70%;">
                        </el-date-picker>
                    </el-col> -->
                    <el-col :span="3">
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Find">
                            查询</el-button>
                        <!-- <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Update">
                            更新</el-button> -->
                    </el-col>
                    <!-- <el-col :span="2">
                        <download-excel class="export-excel-wrapper" :fields="download_excel" name="五险统计表"
                            :fetch="ExportForm" style="top:100px;width:5%">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                导出</el-button>
                        </download-excel>
                    </el-col> -->
                </el-row>
            </div>

            <div style="margin: 5px 3% 0px;overflow-y:hidden;overflow-x: auto;">
                <div style="height: 295px;min-width: 1540px;">
                    <div style="border:1px solid #ccc;width: 99%;height: 370px;">
                        <div
                            style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                            <img src="../../../src/assets/小绿条.png"
                                style="width: 4px; height: 20px;margin-right: 8px;" />
                            <span>五险统计表 </span>
                        </div>
                        <!-- <div style="text-align: right;margin-right:30px;font-size: 14px;position: relative;top:12px;">
                            <span>合计:50 </span>
                        </div> -->

                        <div style="width: 48%;height: 370px;float: left;" id="main1">
                        </div>
                        <div style="width: 48%;height: 370px;float: left;" id="main2">
                        </div>
                    </div>
                    <!-- <div style="border:1px solid #ccc;width: 60%;height: 370px;float: right;">
                        <div
                            style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                            <img src="../../../src/assets/小绿条.png"
                                style="width: 4px; height: 20px;margin-right: 8px;" />
                            <span>合计 </span>
                        </div>
                        <div style="text-align: right;margin-right:30px;font-size: 14px;position: relative;top:12px;">
                            <span>合计:50 </span>
                        </div>

                        <div style="width: 96%;height: 370px;" id="main2">
                        </div>
                    </div> -->
                </div>
            </div>

            <!-- 表格 -->
            <div style="margin:0 3%;margin-top:30px">
                <el-row>
                    <el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" height="574px"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column align="center" label="序号">
                            <template slot-scope="scope_1">
                                {{ scope_1.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="organizeName" align="center" label="架构">
                        </el-table-column>
                        <el-table-column prop="create_time" align="center" label="五险账户">
                            <el-table-column v-for="(item, index) in tableTitle" align="center"
                                :label="item.partner_abbreviation" :key="index">
                                <el-table-column prop="deduction_absence" align="center" label="正常人">
                                    <template slot-scope="scope">
                                        {{ bank1(scope.row.fiveInsuranceCountList, item.partner_abbreviation) }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="残疾人">
                                    <template slot-scope="scope">
                                        {{ bank2(scope.row.fiveInsuranceCountList, item.partner_abbreviation) }}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column align="center" label="合计">
                                <template slot-scope="scope">
                                    {{ bank5(scope.row.fiveInsuranceCountList) }}
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="公积金">
                            <el-table-column v-for="(item, index) in tableTitle" align="center"
                                :label="item.partner_abbreviation" :key="index">
                                <template slot-scope="scope">
                                    {{ bank3(scope.row.accumulationFundCountList, item.partner_abbreviation) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="deduction_absence" align="center" label="合计">
                                <template slot-scope="scope">
                                    {{ bank6(scope.row.accumulationFundCountList) }}
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="create_time" align="center" label="五险公司承担费用">
                            <el-table-column v-for="(item, index) in tableTitle" align="center"
                                :label="item.partner_abbreviation" :key="index">
                                <template slot-scope="scope">
                                    {{ bank4(scope.row.fiveInsuranceMoneyList, item.partner_abbreviation) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="deduction_absence" align="center" label="合计">
                                <template slot-scope="scope">
                                    {{ bank7(scope.row.fiveInsuranceMoneyList) }}
                                </template>
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </el-row>
                <!-- <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row> -->
            </div>

            <!-- 表格 -->
            <!-- <div style="margin:0 3%;margin-top:30px">
                <el-row>
                    <el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" height="574px"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column align="center" label="序号">
                            <template slot-scope="scope_1">
                                {{ scope_1.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="data" align="center" label="架构">
                        </el-table-column>
                        <el-table-column prop="create_time" align="center" label="五险账户">
                            <el-table-column prop="absence_days" align="center" label="环境">
                                <el-table-column prop="deduction_absence" align="center" label="新参保"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="新停保"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="领失业金"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="生育津贴"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="残疾人"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="合计"></el-table-column>
                            </el-table-column>
                            <el-table-column prop="deduction_absence" align="center" label="物业">
                                <el-table-column prop="deduction_absence" align="center" label="新参保"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="新停保"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="领失业金"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="生育津贴"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="残疾人"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="合计"></el-table-column>
                            </el-table-column>
                            <el-table-column prop="deduction_absence" align="center" label="永兴">
                                <el-table-column prop="deduction_absence" align="center" label="新参保"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="新停保"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="领失业金"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="生育津贴"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="残疾人"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="合计"></el-table-column>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="create_time" align="center" label="公积金">
                            <el-table-column prop="absence_days" align="center" label="环境">
                                <el-table-column prop="deduction_absence" align="center" label="新参保"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="新停保"></el-table-column>
                                <el-table-column prop="deduction_absence" align="center" label="合计"></el-table-column>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="create_time" align="center" label="合计">
                            <el-table-column prop="deduction_absence" align="center" label="新参保"></el-table-column>
                            <el-table-column prop="deduction_absence" align="center" label="新停保"></el-table-column>
                            <el-table-column prop="deduction_absence" align="center" label="领失业金"></el-table-column>
                            <el-table-column prop="deduction_absence" align="center" label="生育津贴"></el-table-column>
                            <el-table-column prop="deduction_absence" align="center" label="残疾人"></el-table-column>
                            <el-table-column prop="deduction_absence" align="center" label="合计"></el-table-column>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row>
            </div> -->
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        return {
            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],

            //组织架构数据
            organizeList: [],
            //条件
            condition: {
                organize_ids: []
            },

            //复选框ids
            ids: [],

            //页面相关
            dialogVisible: false,

            download_excel: {
                "架构": "organize_name",
                "五险账户 - 安庭 - 正常人": "induction_manager",
                "五险账户 - 安庭 - 残疾人": "induction_manager",
            },

            tableTitle: [],
            chart: {},
            //五险账户总合计
            wxzhSums: 0,
            //公积金总合计
            gjjSums: 0,
            //五险公司承担费用总合计
            wxgscdfySums: 0,
            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: true,
            },
        }
    },

    methods: {
        //分页
        handleCurrentChange(val) {
            this.page_num = val;
            this.Find();
        },
        //获取表头
        async initializeTableTitle() {
            var tableTitle = await this.$globals.AxiosPost("partner/selectFind", {});
            this.tableTitle = tableTitle.data;
        },
        //图表
        async Find_Tu() {
            echarts.init(document.getElementById('main1')).setOption({
                grid: {
                    top: '40px',
                    left: '70px',
                    right: '40px',
                    bottom: '95px'
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: 'none'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: ['五险账户', '公积金']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: [this.wxzhSums, this.gjjSums],
                    type: 'bar',
                    barWidth: '20%',
                    color: '#008E60',
                }]
            })
            echarts.init(document.getElementById('main2')).setOption({
                grid: {
                    top: '40px',
                    left: '70px',
                    right: '0px',
                    bottom: '95px'
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: 'none'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: ['五险公司承担费用']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: [this.wxgscdfySums],
                    type: 'bar',
                    barWidth: '10%',
                    color: '#008E60',
                }]
            })
        },
        //查询
        async Find() {
            this.wxzhSums = 0;
            this.gjjSums = 0;
            this.wxgscdfySums = 0;
            var organizeSe = '';
            if( this.condition.organize_ids != null && this.condition.organize_ids.length >= 1  ){
                this.organizeS = this.condition.organize_ids[this.condition.organize_ids.length - 1];
                organizeSe = this.organizeS[ this.organizeS.length - 1 ];
            }

            this.initializeTableTitle();
            var url = "report/report/findFiveInsuranceStatisticsList";
            var record = {
                organize_id:organizeSe,
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableData = data;
                    this.total = data.total;

                    this.tableData.some(item => {
                        item.fiveInsuranceCountList.some(item1 => {
                            this.wxzhSums += parseInt(item1.disabilityCount) + parseInt(item1.normalCount)
                        })
                    })

                    this.tableData.some(item => {
                        item.accumulationFundCountList.some(item1 => {
                            this.gjjSums += parseInt(item1.count)
                        })
                    })

                    this.tableData.some(item => {
                        item.fiveInsuranceMoneyList.some(item1 => {
                            if (item1.money) {
                                this.wxgscdfySums = (Number(item1.money) * 1000 + Number(this.wxgscdfySums) * 1000) / 1000;
                            }
                        })
                    })
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
            this.Find_Tu();
        },
        bank1(list, e) {
            var normalCount = '';
            list.some(item => {
                if (item.partnerAbbreviation == e) {
                    normalCount = item.normalCount;
                    return true;
                }
            })
            return normalCount;
        },
        bank2(list, e) {
            var disabilityCount = '';
            list.some(item => {
                if (item.partnerAbbreviation == e) {
                    disabilityCount = item.disabilityCount;
                    return true;
                }
            })
            return disabilityCount;
        },
        bank3(list, e) {
            var count = '';
            list.some(item => {
                if (item.partnerAbbreviation == e) {
                    count = item.count;
                    return true;
                }
            })
            return count;
        },
        bank4(list, e) {
            var money = '';
            list.some(item => {
                if (item.partnerAbbreviation == e) {
                    money = item.money;
                    return true;
                }
            })
            return money;
        },
        bank5(list) {
            var sums = 0;
            list.some(item => {
                sums += Number(item.disabilityCount) + Number(item.normalCount);
            })
            return sums;
        },
        bank6(list) {
            var sums = 0;
            list.some(item => {
                sums = Number(item.count) + Number(sums);
            })
            return sums;
        },
        bank7(list) {
            var sums = 0;
            list.some(item => {
                if (item.money) {
                    sums = (Number(item.money) * 1000 + Number(sums) * 1000) / 1000;
                }
            })
            return sums;
        },
        //初始化组织架构及下面的人
        async organizeFind() {
            var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                identification: "1",
            });
            this.organizeList = this.getTreeData(organizeList.data);

        },
        getTreeData(data) {
            // 循环遍历json数据
            for (var i = 0; i < data.length; i++) {

                if (data[i].organizeList.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].organizeList = undefined;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].organizeList);
                }
            }
            return data;
        }
    },
    created() {
        this.Find();
        this.organizeFind();
    }
}
</script>

<style scoped="scoped">
.el-button--goon:focus,
.el-button--goon:hover {
    background: #006E4B;
    color: #fff;
}

.el-button--goon {
    color: #FFF;
    background-color: #006E4B;
    width: 85px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.el-table__body-wrapper {
    height: 430px !important;
}
</style>


// WEBPACK FOOTER //
// five_insurances_statistical.vue?3c020476